export const ImageGridTool = {
    convert: (labelSrc, imgSrc, data) => {
        let labelValue = ""
        let imgValue = ""

        if (!isArray(data)) {
            data = Object.entries(data).map((item) => {
                return item[1];
            })
        }

        data.forEach(item => {
            labelValue = item[labelSrc]
            imgValue = item[imgSrc]
            delete item[labelSrc]
            delete item[imgSrc]
            item.img = imgValue
            item.label = labelValue
        })
        return data
    }
}

const isArray = function(a) {
    return (!!a) && (a.constructor === Array);
}



// WEBPACK FOOTER //
// ./src/tools/ImageGridTool.js